import { render } from "./tscy.vue?vue&type=template&id=8f0a7b16&scoped=true"
import script from "./tscy.vue?vue&type=script&lang=js"
export * from "./tscy.vue?vue&type=script&lang=js"

import "./tscy.vue?vue&type=style&index=0&id=8f0a7b16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f0a7b16"]])

export default __exports__